import styles from './Footer.module.css';

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <span className={styles.address}>REFUGE · 366 TEN EYCK · BROOKLYN NY</span>
        <span className={styles.copyright}>© 2026 REFUGE</span>
      </div>
    </footer>
  );
}
